var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "user-avatar-dropdown" },
    [
      _c(
        "Dropdown",
        { on: { "on-click": _vm.handleClick } },
        [
          _c("span", [
            _c("strong", [
              _vm._v(
                _vm._s(_vm.userNickName) + "(" + _vm._s(_vm.userName) + ")"
              ),
            ]),
          ]),
          _c("Icon", { attrs: { size: 18, type: "md-arrow-dropdown" } }),
          _c(
            "DropdownMenu",
            { attrs: { slot: "list" }, slot: "list" },
            [
              _c("DropdownItem", { attrs: { name: "changePassword" } }, [
                _vm._v("个人中心"),
              ]),
              _c("DropdownItem", { attrs: { name: "logout" } }, [
                _vm._v("退出登录"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }